import React from 'react';
import { useTranslation } from '@app/core/i18n';

import { Button } from '@ast/magma/components/button';
import { Dialog } from '@ast/magma/components/dialog';

import { EventLogItem } from '@app/queryTyping';

import { DialogWrapper } from '@app/common/components/dialogwrapper';
import { useIsMobile } from '@app/common/utils/hooks/useIsMobile';

import styles from './EventLogDetails.pcss';

type Props = {
  event: EventLogItem | null;
  onClose: () => void;
};

export const EventLogDetails = React.memo<Props>(({ event, onClose }) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <DialogWrapper visible={!!event}>
      <Dialog
        className={styles.dialog}
        title={t('event-log-details.title|Details title', 'Details')}
        predefinedWidth="md"
        align={isMobile ? 'bottom' : 'right'}
        onClose={onClose}
        closeOnMouseDownOutside
        showClose={{
          'aria-label': t(
            'event-log-details.closeButton|User Event Full Info close dialog label',
            'Close Event log details',
          ),
        }}
      >
        <div className={styles.dialogContainer}>
          <div className={styles.details}>
            <div
              className={styles.item}
              data-stable-name="UserName"
            >
              <span className={styles.itemTitle}>
                {t('event-log-details.user|User name', 'User')}
              </span>
              <span>{event?.userFullName}</span>
            </div>
            <div
              className={styles.item}
              data-stable-name="EventName"
            >
              <span className={styles.itemTitle}>
                {t('event-log-details.event|Event name', 'Event')}
              </span>
              <span>{event?.eventTypeName}</span>
            </div>
            <div
              className={styles.item}
              data-stable-name="IPAddress"
            >
              <span className={styles.itemTitle}>
                {t('event-log-details.ipAddress|IP address', 'IP address')}
              </span>
              <span>{event?.ipAddress}</span>
            </div>
            <div
              className={styles.item}
              data-stable-name="Description"
            >
              <span className={styles.itemTitle}>
                {t('event-log-details.description|Description', 'Description')}
              </span>
              <span>{event?.description}</span>
            </div>
          </div>
          <Button
            look="outlined"
            onClick={() => {
              onClose();
            }}
          >
            {t(
              'event-log-details.cancelButton|User Event Full Info cancel dialog button',
              'Close',
            )}
          </Button>
        </div>
      </Dialog>
    </DialogWrapper>
  );
});
